function PublicDashboard() {
    return (
        <div>
            Public dashboard
        </div>
    )
}

export default PublicDashboard;
